/**
 * Minimalerei Cross-Sell Slider
 *
 * Initializes every [data-mp-xss] slider on the page:
 *   - Arrows step left/right by 2 cards (desktop) or 1 (mobile)
 *   - Dot pagination computed from total page count
 *   - Touch/swipe + ArrowLeft/Right keyboard support
 *   - Resize re-runs visible-count + page math (debounced 150ms)
 *
 * Each slider keeps its own state so multiple instances on a page
 * don't interfere. A data-mp-xss-initialized flag prevents double-
 * init if the script ever re-runs (Dawn section re-render etc.).
 */
(function () {
  'use strict';

  function getVisibleCount() {
    var w = window.innerWidth;
    if (w <= 768) return 1;
    if (w <= 1024) return 3;
    return 4;
  }

  function getStep() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  function initSlider(slider) {
    if (slider.dataset.mpXssInitialized === 'true') return;
    slider.dataset.mpXssInitialized = 'true';

    var track = slider.querySelector('[data-mp-xss-track]');
    var prevBtn = slider.querySelector('[data-mp-xss-prev]');
    var nextBtn = slider.querySelector('[data-mp-xss-next]');
    var dotsContainer = slider.querySelector('[data-mp-xss-dots]');

    if (!track || !prevBtn || !nextBtn || !dotsContainer) return;

    var cards = Array.from(track.querySelectorAll('.mp-xss__card'));
    if (cards.length === 0) return;

    var currentIndex = 0;
    var touchStartX = 0;
    var touchEndX = 0;

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisibleCount());
    }

    function getPageCount() {
      var step = getStep();
      return Math.ceil((cards.length - getVisibleCount()) / step) + 1;
    }

    function getCurrentPage() {
      return Math.round(currentIndex / getStep());
    }

    function renderDots() {
      var pages = getPageCount();
      dotsContainer.innerHTML = '';

      if (pages <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = 'flex';

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mp-xss__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Seite ' + (i + 1) + ' von ' + pages);
        if (i === getCurrentPage()) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        }
        (function (pageIndex) {
          dot.addEventListener('click', function () { goToPage(pageIndex); });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function updateTransform() {
      var card = cards[0];
      if (!card) return;
      var cardWidth = card.offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      var offset = currentIndex * (cardWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
    }

    function updateArrows() {
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function updateDots() {
      var allDots = dotsContainer.querySelectorAll('.mp-xss__dot');
      var activePage = getCurrentPage();
      allDots.forEach(function (dot, i) {
        if (i === activePage) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    function goToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      updateTransform();
      updateArrows();
      updateDots();
    }

    function goToPage(page) {
      goToIndex(page * getStep());
    }

    function next() { goToIndex(currentIndex + getStep()); }
    function prev() { goToIndex(currentIndex - getStep()); }

    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
    }, { passive: true });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        renderDots();
        updateTransform();
        updateArrows();
      }, 150);
    });

    renderDots();
    updateTransform();
    updateArrows();
  }

  function boot() {
    document.querySelectorAll('[data-mp-xss]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
